<template>
  <page>
    <owner-sidebar slot="sidebar"/>
    <span slot="header">Organization Management</span>
    <b-tabs card no-fade @input="clearForm">
      <b-tab title="All" active>
        <all/>
      </b-tab>
      <b-tab title="Archived">
        <archived/>
      </b-tab>
      <b-tab title="<i class='fas fa-plus'></i> Add">
        <add ref="add"/>
      </b-tab>
    </b-tabs>
  </page>
</template>

<script>
import page from '../../../templates/page'
import ownerSidebar from '../../../sidebar/owner'
import all from './all'
import add from './add'
import archived from './archived'

export default {
  components: {
    add,
    all,
    archived,
    ownerSidebar,
    page
  },
  methods: {
    clearForm (e) {
      if (!this.$refs.add.saving) {
        this.$refs.add.resetForm()
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/admin/organizations/index.vue